import ProtectedRoute from "routes/ProtectedRoute";

const previewRoutes = [
  {
    path: "briefcase-preview/:spaceId",
    lazy: async () => {
      const mod = await import(
        "views/Admin/Briefcase/BriefcasePreview/BriefcasePreview"
      );
      const BriefcasePreview = mod.default;
      return {
        Component: () => (
          <ProtectedRoute>
            <BriefcasePreview />
          </ProtectedRoute>
        ),
      };
    },
  },

  {
    path: "document-preview/:documentId",
    lazy: async () => {
      const mod = await import("views/Admin/Workspace/DocumentPreview");
      const DocumentPreview = mod.default;
      return {
        Component: () => (
          <ProtectedRoute>
            <DocumentPreview />
          </ProtectedRoute>
        ),
      };
    },
  },

  {
    path: "events/preview/:eventId",
    lazy: async () => {
      const mod = await import("components/Admin/Events/EventsPreview");
      const EventsPreview = mod.default;
      return {
        Component: () => (
          <ProtectedRoute>
            <EventsPreview />
          </ProtectedRoute>
        ),
      };
    },
  },

  {
    path: "events/preview/:eventId/:sessionId",
    lazy: async () => {
      const mod = await import("components/Admin/Events/EventsPreview");
      const EventsPreview = mod.default;
      return {
        Component: () => (
          <ProtectedRoute>
            <EventsPreview />
          </ProtectedRoute>
        ),
      };
    },
  },

  {
    path: "events/document-preview/:eventId/:documentId",
    lazy: async () => {
      const mod = await import("components/Admin/Events/EventDocumentPreview");
      const EventDocumentPreview = mod.default;
      return {
        Component: () => (
          <ProtectedRoute>
            <EventDocumentPreview />
          </ProtectedRoute>
        ),
      };
    },
  },
];

export default previewRoutes;
